import { render, staticRenderFns } from "./columnPannel.vue?vue&type=template&id=0a11ad0a"
import script from "./columnPannel.vue?vue&type=script&lang=js"
export * from "./columnPannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports